import { useState } from "react";
import { Share2, Copy, Check, Twitter, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Shareable victory card — extracted from XPSummary. */
export default function SharePanel({ winnerName, winnerValue, meleeCount }) {
  const [linkCopied, setLinkCopied] = useState(false);

  const highlight =
    meleeCount >= 3 ? `survived ${meleeCount} Market Melee cards`
    : winnerValue >= 1200 ? `dominated with $${winnerValue} in crypto`
    : winnerValue >= 1000 ? "a strategic victory"
    : "a crypto comeback";
  const shareText = `${winnerName} won Market Melee with $${winnerValue} - ${highlight} 🚀 #MarketMelee`;
  const shareUrl = typeof window !== "undefined" ? window.location.origin : "";

  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const copyShareLink = () => {
    navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  const downloadVictoryImage = () => {
    const canvas = document.createElement("canvas");
    canvas.width = 1080; canvas.height = 1080;
    const ctx = canvas.getContext("2d");
    const grad = ctx.createLinearGradient(0, 0, 1080, 1080);
    grad.addColorStop(0, "#1A237E"); grad.addColorStop(1, "#38B6FF");
    ctx.fillStyle = grad; ctx.fillRect(0, 0, 1080, 1080);
    ctx.fillStyle = "#FFFFFF"; ctx.textAlign = "center";
    ctx.font = "bold 72px system-ui, sans-serif";
    ctx.fillText("MARKET MELEE", 540, 200);
    ctx.font = "36px system-ui, sans-serif";
    ctx.fillText("Victory", 540, 270);
    ctx.font = "220px system-ui, sans-serif"; ctx.fillText("🏆", 540, 510);
    ctx.font = "bold 64px system-ui, sans-serif"; ctx.fillText(winnerName, 540, 640);
    ctx.fillStyle = "#FFC107"; ctx.font = "bold 100px system-ui, sans-serif";
    ctx.fillText(`$${winnerValue}`, 540, 780);
    ctx.fillStyle = "#FFFFFFAA"; ctx.font = "32px system-ui, sans-serif";
    const maxWidth = 900;
    const words = highlight.split(" "); let line = ""; let y = 870;
    words.forEach((w) => {
      const test = line + w + " ";
      if (ctx.measureText(test).width > maxWidth) { ctx.fillText(line.trim(), 540, y); line = w + " "; y += 42; }
      else line = test;
    });
    if (line) ctx.fillText(line.trim(), 540, y);
    ctx.fillStyle = "#FFFFFF66"; ctx.font = "28px system-ui, sans-serif";
    ctx.fillText("#MarketMelee", 540, 1020);
    canvas.toBlob((blob) => {
      if (!blob) return;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `market-melee-victory-${Date.now()}.png`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    }, "image/png");
  };

  return (
    <div className="mt-5 pt-4 border-t-2 border-[#1A237E]/10 dark:border-[#E3F2FD]/10" data-testid="share-victory-panel">
      <div className="flex items-center gap-2 mb-3">
        <Share2 className="w-4 h-4 text-[#38B6FF]" />
        <h3 className="text-sm font-bold text-[#1A237E] dark:text-[#E3F2FD]" style={{ fontFamily: "Fredoka" }}>Share Victory</h3>
      </div>
      <div className="bg-gradient-to-br from-[#1A237E] to-[#38B6FF] rounded-2xl p-4 mb-3 text-center">
        <p className="text-white/80 text-xs mb-1">🏆 Market Melee Victory</p>
        <p className="text-white text-xl font-bold" style={{ fontFamily: "Fredoka" }}>{winnerName}</p>
        <p className="text-[#FFC107] text-3xl font-bold my-1" style={{ fontFamily: "Fredoka" }}>${winnerValue}</p>
        <p className="text-white/70 text-xs italic">{highlight}</p>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Button data-testid="share-twitter-btn" onClick={shareToTwitter} variant="outline"
          className="rounded-xl border-[#1A237E]/20 dark:border-[#E3F2FD]/20 hover:bg-[#1DA1F2]/10 h-10 text-xs">
          <Twitter className="w-3.5 h-3.5 mr-1" /> X / Twitter
        </Button>
        <Button data-testid="share-download-btn" onClick={downloadVictoryImage} variant="outline"
          className="rounded-xl border-[#1A237E]/20 dark:border-[#E3F2FD]/20 hover:bg-[#E1306C]/10 h-10 text-xs">
          <TrendingUp className="w-3.5 h-3.5 mr-1" /> Image
        </Button>
        <Button data-testid="share-copy-btn" onClick={copyShareLink} variant="outline"
          className="rounded-xl border-[#1A237E]/20 dark:border-[#E3F2FD]/20 hover:bg-[#38B6FF]/10 h-10 text-xs">
          {linkCopied ? <Check className="w-3.5 h-3.5 mr-1 text-green-500" /> : <Copy className="w-3.5 h-3.5 mr-1" />}
          {linkCopied ? "Copied" : "Copy"}
        </Button>
      </div>
    </div>
  );
}
